import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import {
    fetchGetFundingRequirements,
    GetFundingRequirementsResponse
} from '@iwoca/lapi-client/edge_de';
import { useQuery } from '@tanstack/react-query';

import { useFundingRequirementsParams } from './useFundingRequirementsParams';

export function useGetFundingRequirements(): GetFundingRequirementsResponse['data'] {
    const { offerId, drawdownAmount } = useFundingRequirementsParams();

    const { data } = useQuery({
        queryKey: ['fetchGetFundingRequirements', offerId, drawdownAmount],
        queryFn: () =>
            fetchGetFundingRequirements({
                offerId,
                query: { cash_amount: drawdownAmount }
            }),
        select: (response) => response.data,
        suspense: true
    });

    if (!data) {
        const message = `useGetFundingRequirements: funding requirements not found: ${offerId}`;
        logError(message, { tags: TAGS.DE_LENDING });
        throw new Error(message);
    }

    return data;
}
